import React from 'react';
import { CSVLink } from 'react-csv';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Card from '@components/Card';
import useAPI from '@hooks/useAPI';
import Spinner from '@shared/Spinner';

import LookupWidget from './components/LookupWidget';
import SanctionList from './SanctionList';
import Thresholds from './Thresholds';

const Container = styled.div`
  padding: 50px 0px 0px;
`;

const DownloadListButton = ({ data }) => {
  const nowTs = new Date().toLocaleString();
  const csvTitle = `lists-${nowTs}.csv`;

  return (
    <Container>
      <CSVLink data={data} filename={csvTitle}>
        <button>Download Active Lists as CSV</button>
      </CSVLink>
    </Container>
  );
};

export default function UserProfile() {
  const customer_id = process.env.REACT_APP_CUSTOMER_ID;
  const sanctionsConfig = useAPI('get', 'ScreenConsoleApi', `list`, '');
  const thresholdsConfig = useAPI(
    'get',
    'ScreenConsoleApi',
    `config/${customer_id}/thresholds`,
    '',
    false,
    '',
    false
  );
  const invalidateCache = () => {
    sanctionsConfig.invalidateCache();
  };

  const listData = sanctionsConfig?.response?.body;
  const filteredListData = listData && listData.filter(item => item.status === 'Confirmed');
  const hasResults = listData && listData.length > 0;
  const isSanctionsLoading = sanctionsConfig.isLoading;
  const isThresholdsLoading = thresholdsConfig.isLoading;
  const hasthresholdData = thresholdsConfig.response != null;
  const apiKey = useSelector(state => state.keys.key);

  if (!apiKey){
    return <SpinnerContainer>
      <Spinner center />
    </SpinnerContainer>
  }
  return (
    <>
      <Helmet>
        <title>Lists</title>
      </Helmet>
      <Card title='Entity Lookup' shadow>
        <LookupWidget />
      </Card>
      <hr />
      <Card title='Sanctions Lists' shadow>
        {hasResults && (
          <SanctionList data={listData} invalidateCache={invalidateCache} />
        )}
        {isSanctionsLoading && <Spinner />}
        {!hasResults && !isSanctionsLoading && (
          <div>
            Unable to fetch lists. Please email{' '}
            <a href='mailto:screen-support@enigma.com'>
              screen-support@enigma.com
            </a>{' '}
            for help.
          </div>
        )}
        {hasResults && <DownloadListButton data={filteredListData} />}
      </Card>
      <hr />
      <Card title='Threshold Management' shadow>
        {isThresholdsLoading && <Spinner/>}
        {hasthresholdData && (
        <Thresholds data={thresholdsConfig}></Thresholds>
        )}
      </Card>
    </>
  );
}

const SpinnerContainer = styled.div`
  height: 80vh;
`;